import { Component, OnInit,  ChangeDetectionStrategy,OnChanges,SimpleChanges,Input } from '@angular/core';
import Chart from 'chartjs-gauge';
@Component({
  selector: 'sb-chart-gauge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gauge-chart.component.html',
  styleUrls: ['./gauge-chart.component.css']
})
export class GaugeChartComponent implements OnInit,OnChanges {
  @Input() dataChart: {data: number[]; title: string, fontSize:number,cutoutPercentage:number,unit:string};
  @Input() chartInputId:any;
  chart: any;
  chartId: string="1";
  title: string;
  unit:string=null;
  constructor() { }
  
  ngOnInit(): void {
    this.chartId=this.chartInputId;    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataChart.currentValue) {      
      this.renderGaugeChart();
    }
  }
  renderGaugeChart(){
    let chartWidth =
  document.querySelector('.boxGaugeChart').getBoundingClientRect().width - 40;
  const canvasElement=<HTMLCanvasElement> document.getElementById(this.chartId);
  const ctx =canvasElement.getContext('2d');
  const gradient = ctx.createLinearGradient(0, 0, chartWidth, 0);
    gradient.addColorStop(0, "red");
    gradient.addColorStop(0.3,"orange");
    gradient.addColorStop(0.6, "yellow");
    gradient.addColorStop(1,"green");
    this.title=this.dataChart.title;
    this.unit=this.dataChart.unit?' '+this.dataChart.unit:null;
    this.chart =  new Chart(this.chartId, {
      type: 'gauge',
      data: {
        datasets: [{
          value: 95.8,
          minValue: 0,
          data: [800],
          backgroundColor: [gradient],
          borderWidth: 1,
        }]
      },
      options: {
        cutoutPercentage : this.dataChart.cutoutPercentage?this.dataChart.cutoutPercentage: 85, 
        needle: {
          radiusPercentage: 1,
          widthPercentage: 1.5,
          lengthPercentage: 80,
          color: 'rgba(0, 0, 0, 1)',
        },
        valueLabel: {
          display: true,
          formatter: (value) => {
            return value + this.unit;
          },
          color: 'red',
          bottomMarginPercentage:15,
          backgroundColor: 'transparent',
          borderRadius:1,
          fontSize:this.dataChart.fontSize?this.dataChart.fontSize:20
        },
      }
    });
  }
}
